ACC.productDetail = {

    _autoload: [
        "initPageEvents",
        "bindVariantOptions",
        "bindImageGallery",
        "SimilarItemsCarousel",
        "showSpecification"
    ],

    showSpecification: function () {
        $('.tabhead:has(a.specs-tab-title)').on('click', function () {
            let modelNumber = $('#productModelNumber').val();
            if (!isNullUndefined(modelNumber)) {
				$('.product-classifications-box').removeClass('d-none');
                $.ajax({
                    url: ACC.config.encodedContextPath + "/getSpecification?modelNumber=" + modelNumber,
                    type: "GET",
                    contentType: 'application/json',
                    dataType: "json",
                    success: function (response) {
                        if (isNullUndefined(response)) {
                            $('.product-specs-list').addClass('d-none');
                        } else {
                            let spec = JSON.stringify(response);
                            let result = $.parseJSON(spec);
                            var showSpec = "<ul>";
                            $.each(result, function (k, v) {
                                showSpec += '<li>' + k + " : " + v + "</li>";
                            });
                            showSpec += '</ul>';
                            $('.product-specs-list').html(showSpec);
                        }
                    },
                    error: function () {
                        $('.product-specs-list').addClass('d-none');
                        console.log("Error while getting product specification for extended aisle product");
                    },
                });
            }
        })
    },

    SimilarItemsCarousel: function () {
        $(".js-owl-carousel-SimilarItems-PDP").owlCarousel({
            items: 1,
            margin: 8,
            nav: false,
            autoWidth:true,
            autoplay: false,
            dots: false,
            loop: false,
        });
    },
    bindImageGallery: function () {
        var sync1 = $("#pdp-main-slider");
        var sync2 = $("#pdpImgThumbnail");
        var syncedSecondary = true;

        if (!isNullUndefined(sync1) && !isNullUndefined(sync2)) {
            sync1.owlCarousel({
                items: 1,
                margin: 10,
                slideSpeed: 2000,
                nav: true,
                autoplay: false,
                dots: false,
                loop: false,
                responsiveRefreshRate: 200,
                navText: [$("<span>").addClass('chevron-left').html(`<img src="${ACC.config.commonResourcePath}/images/acima-icons/chevron-left.svg"/>`), $("<span>").addClass('chveron-right').html(`<img src="${ACC.config.commonResourcePath}/images/acima-icons/chevron-right.svg">`)],
            }).on('changed.owl.carousel', syncPosition);

            sync2.on('initialized.owl.carousel', function () {
            sync2.find(".owl-item").eq(0).addClass("current");
            }).owlCarousel({
                    items: 4,
                    dots: false,
                    nav: false,
                    loop: false,
                    autoWidth:true,
                    margin: 8,
                    smartSpeed: 200,
                    slideSpeed: 500,
                    slideBy: 1,
                    responsiveRefreshRate: 100
                }).on('changed.owl.carousel', syncPosition2);

            function syncPosition(el) {
                //if you set loop to false, you have to restore this next line
                var current = el.item.index;

                //if you disable loop you have to comment this block
                // var count = el.item.count - 1;
                // var current = Math.round(el.item.index - (el.item.count / 2) - .5);

                // if (current < 0) {
                // 	current = count;
                // }
                // if (current > count) {
                // 	current = 0;
                // }

                //end block

                sync2
                    .find(".owl-item")
                    .removeClass("current")
                    .eq(current)
                    .addClass("current");
                var onscreen = sync2.find('.owl-item.active').length - 1;
                var start = sync2.find('.owl-item.active').first().index();
                var end = sync2.find('.owl-item.active').last().index();

                if (current > end) {
                    sync2.data('owl.carousel').to(current, 100, true);
                }
                if (current < start) {
                    sync2.data('owl.carousel').to(current - onscreen, 100, true);
                }
            }
            function syncPosition2(el) {
                if (syncedSecondary) {
                    var number = el.item.index;
                    sync1.data('owl.carousel').to(number, 100, true);
                }
            }
            sync2.on("click", ".owl-item", function (e) {
                e.preventDefault();
                var number = $(this).index();
                sync1.trigger('to.owl.carousel', [$(e.target).parents('.owl-item').index(), 300, true]);
            });
        }

    },
    checkQtySelector: function (self, mode) {
        var $qtySelector = $(document).find(self).parents(".js-qty-selector");
        var input = $qtySelector.find(".js-qty-selector-input");
        var inputVal = parseInt(input.val());
        var max = input.data("max");
        var minusBtn = $qtySelector.find(".js-qty-selector-minus");
        var plusBtn = $qtySelector.find(".js-qty-selector-plus");

        $qtySelector.find(".btn").removeAttr("disabled");

        if (mode == "minus") {
            if (inputVal != 1) {
                ACC.productDetail.updateQtyValue(self, inputVal - 1)
                if (inputVal - 1 == 1) {
                    minusBtn.attr("disabled", "disabled")
                }

            } else {
                minusBtn.attr("disabled", "disabled")
            }
        } else if (mode == "reset") {
            ACC.productDetail.updateQtyValue(self, 1)

        } else if (mode == "plus") {
            if (max == "FORCE_IN_STOCK") {
                ACC.productDetail.updateQtyValue(self, inputVal + 1)
            } else if (inputVal <= max) {
                ACC.productDetail.updateQtyValue(self, inputVal + 1)
                if (inputVal + 1 == max) {
                    plusBtn.attr("disabled", "disabled")
                }
            } else {
                plusBtn.attr("disabled", "disabled")
            }
        } else if (mode == "input") {
            if (inputVal == 1) {
                minusBtn.attr("disabled", "disabled")
            } else if (max == "FORCE_IN_STOCK" && inputVal > 0) {
                ACC.productDetail.updateQtyValue(self, inputVal)
            } else if (inputVal == max) {
                plusBtn.attr("disabled", "disabled")
            } else if (inputVal < 1) {
                ACC.productDetail.updateQtyValue(self, 1)
                minusBtn.attr("disabled", "disabled")
            } else if (inputVal > max) {
                ACC.productDetail.updateQtyValue(self, max)
                plusBtn.attr("disabled", "disabled")
            }
        } else if (mode == "focusout") {
            if (isNaN(inputVal)) {
                ACC.productDetail.updateQtyValue(self, 1);
                minusBtn.attr("disabled", "disabled");
            } else if (inputVal >= max) {
                plusBtn.attr("disabled", "disabled");
            }
        }

    },

    updateQtyValue: function (self, value) {
        var input = $(document).find(self).parents(".js-qty-selector").find(".js-qty-selector-input");
        var addtocartQty = $(document).find(self).parents(".addtocart-component").find("#addToCartForm").find(".js-qty-selector-input");
        var configureQty = $(document).find(self).parents(".addtocart-component").find("#configureForm").find(".js-qty-selector-input");
        input.val(value);
        addtocartQty.val(value);
        configureQty.val(value);
    },

    initPageEvents: function () {
        $(document).on("click", '.js-qty-selector .js-qty-selector-minus', function () {
            ACC.productDetail.checkQtySelector(this, "minus");
        })

        $(document).on("click", '.js-qty-selector .js-qty-selector-plus', function () {
            ACC.productDetail.checkQtySelector(this, "plus");
        })

        $(document).on("keydown", '.js-qty-selector .js-qty-selector-input', function (e) {

            if (($(this).val() != " " && ((e.which >= 48 && e.which <= 57) || (e.which >= 96 && e.which <= 105))) || e.which == 8 || e.which == 46 || e.which == 37 || e.which == 39 || e.which == 9) {
            }
            else if (e.which == 38) {
                ACC.productDetail.checkQtySelector(this, "plus");
            }
            else if (e.which == 40) {
                ACC.productDetail.checkQtySelector(this, "minus");
            }
            else {
                e.preventDefault();
            }
        })

        $(document).on("keyup", '.js-qty-selector .js-qty-selector-input', function (e) {
            ACC.productDetail.checkQtySelector(this, "input");
            ACC.productDetail.updateQtyValue(this, $(this).val());

        })

        $(document).on("focusout", '.js-qty-selector .js-qty-selector-input', function (e) {
            ACC.productDetail.checkQtySelector(this, "focusout");
            ACC.productDetail.updateQtyValue(this, $(this).val());
        })

        $("#Size").change(function () {
            changeOnVariantOptionSelection($("#Size option:selected"));
        });

        $("#variant").change(function () {
            changeOnVariantOptionSelection($("#variant option:selected"));
        });

        $(".selectPriority").change(function () {
            window.location.href = $(this[this.selectedIndex]).val();
        });

        function changeOnVariantOptionSelection(optionSelected) {
            window.location.href = optionSelected.attr('value');
        }
    },

    bindVariantOptions: function () {
        ACC.productDetail.bindCurrentStyle();
        ACC.productDetail.bindCurrentSize();
        ACC.productDetail.bindCurrentType();
    },

    bindCurrentStyle: function () {
        var currentStyle = $("#currentStyleValue").data("styleValue");
        var styleSpan = $(".styleName");
        if (currentStyle != null) {
            styleSpan.text(": " + currentStyle);
        }
    },

    bindCurrentSize: function () {
        var currentSize = $("#currentSizeValue").data("sizeValue");
        var sizeSpan = $(".sizeName");
        if (currentSize != null) {
            sizeSpan.text(": " + currentSize);
        }
    },

    bindCurrentType: function () {
        var currentSize = $("#currentTypeValue").data("typeValue");
        var sizeSpan = $(".typeName");
        if (currentSize != null) {
            sizeSpan.text(": " + currentSize);
        }
    }
};

function toInactiveVariants() {
    let selectedDimensionMap = "";
    let newDimensionArray = [];

    $('#dimensions ul').each(function (i) { // Build the selected dimension map
        let dimension = $(this).attr("data-dimension-name");
        let dimensionMap = $('input[name="' + dimension + '"]:checked').data('dimension-map');
        if (!isNullUndefined(dimensionMap)) {
            selectedDimensionMap += (selectedDimensionMap.length > 0 ? '-' : '') + dimensionMap;
        }
    });
    let splitedDefaultValue = selectedDimensionMap.split('-');
    let uniqueFlatArray = [];
    $('#multi-variations span').each(function (i) {
        let index = 0;
        let dataValue = $(this).attr("data-combination-map");
        let splitDataValue = dataValue.split('-');

        for (i = 0; i < splitDataValue.length; i++) {
            if (splitDataValue[i] === splitedDefaultValue[i]) {
                index++;
            }
        }
        if (index >= splitedDefaultValue.length - 1) {
            newDimensionArray.push($(this).data('combination-map'))
        }
        let flatArray = $.map(newDimensionArray, function (element) {
            return element.split('-');
        });
        uniqueFlatArray = [...new Set(flatArray)];
    })

    let allVariantsDimensions = [];

    $('#dimensions ul').each(function () {
        $(this).find('li').each(function () {
            let allDimensionMap = $(this).find('input').data('dimension-map');
            allVariantsDimensions.push(String(allDimensionMap));
        });
    });

    // // Loop through the first array
    allVariantsDimensions.forEach(function (element) {
        if (uniqueFlatArray.includes(element)) {
            if ($('input[data-dimension-map="' + element + '"]').siblings('label').hasClass('variant-checked')) {

            } else {
                $('input[data-dimension-map="' + element + '"]').siblings('label').addClass('available').removeClass('inactive');
            }
        } else {
            $('input[data-dimension-map="' + element + '"]').siblings('label').addClass('inactive').removeClass('available');
        }
    });
}

function toDisableVariants() {
    $('#dimensions ul').each(function (index) {
        let concatenatedDimensionMap;
        $(this).find("li").each(function () {
            let dimensionMap = $(this).find("input").data("dimension-map");
            if ($('#dimensions ul').length > 1) {
                concatenatedDimensionMap = (index === 0 ? dimensionMap + "-" : (index === $("#dimensions ul").length - 1 ? "-" + dimensionMap : "-" + dimensionMap + "-"));
            } else {
                concatenatedDimensionMap = dimensionMap;
            }

            $('#multi-variations span').each(function (i) {
                let dataValue = $(this).attr("data-combination-map");
                if (dataValue.includes(concatenatedDimensionMap)) {
                    let correspondingInput = $("input[data-dimension-map='" + dimensionMap + "']");
                    correspondingInput.prop('disabled', false);
                    correspondingInput.next("label").removeClass("variant-disabled")
                    return false;
                }
                else {
                    let correspondingInput = $("input[data-dimension-map='" + dimensionMap + "']");
                    correspondingInput.prop('disabled', true);
                    correspondingInput.next("label").addClass("variant-disabled")
                }
            });
        });
    });

    $('#dimensions ul li').has('label.variant-disabled').remove();
}

function getVariantsAvailability() {
    let productCodes = [];
    $('#multi-variations span').each(function() {
        productCodes.push($(this).attr('id'));
    });
    processBatch(productCodes, 0);
}

function processBatch(productCodes, startIndex) {
    let batchSize = 10;
    let endIndex = Math.min(startIndex + batchSize, productCodes.length);
    let batch = productCodes.slice(startIndex, endIndex);

    $.ajax({
        url: ACC.config.encodedContextPath + '/common-api-product/get-variants-availability',
        type: 'GET',
        data: { productCodes: batch.join(',') },
        timeout: 59000,
        success: function(response) {
            if (response) {
                for (var key in response) {
                    if (response.hasOwnProperty(key)) {
                        var availability = response[key];
                        if (availability === 'false') {
                            $("#" + key).remove();
                        }
                    }
                }
            }
        },
        error: function() {
            console.log("Error getting variants availability");
        },
        complete: function() {
            if (endIndex < productCodes.length) {
                // If there are more product codes, process the next batch
                processBatch(productCodes, endIndex);
            } else {
                // No more product codes, perform final actions
                toInactiveVariants();
                toDisableVariants();
                $('.product-variant .product-combination').removeClass('loading-animation');
            }
        }
    });
}
$(window).on('load', function() { 
	if (isElemExist('#checkVariantsAvailability')) {
		let checkVariantsAvailability = $("#checkVariantsAvailability").val();
		if (isTrue(checkVariantsAvailability)) {
			getVariantsAvailability();
		}
	}
});

$(document).ready(function() {
    
    $('#dimensions ul').each(function (index, ulElement) {
        let dimension = $(this).attr("data-dimension-name");
        let selectedVariants = $('input[name="' + dimension + '"]:checked').attr("id");
        $('h3#' + dimension).after('<span class="font-primary fw-700 ">' + selectedVariants + '</span>');
    });

	//Variant onChange code
	/*  1. Onchange or on selection of the variant input which are available, data-dimension-map of the checked inputs are selected and stored 
		them in selectedDimensionMap eg.(01-12-20) then compare it with the available combination in #multi-variation span if true then set the product in url.
	    
		2. Onselection of the variant which is disabled, the data-dimension-map of the radio button which is clicked is stored in selectedDimension. Also the 
		selectedDimensionMap is split and stored in dimensionArray eg["00","12","20"]. And all the possible available combination with selectedDimension are
		stored inside newList array. Afterwards these arrays are populated and compared with dimensionArray and possible product is set in url accordingly.
	*/

	$('#dimensions input[type="radio"]').on('change', function() {
		let productCatUrl = $('input[name="categoryPath"]').val();
		$('.full-page-spinner').removeClass('d-none');
		//Retrieve the selected dimension
		var selectedDimension = $(this).attr('data-dimension-map');
		var selectedDimensionMap = "";
		$('#dimensions ul').each(function(i) { // Build the selected dimension map
			var dimension = $(this).attr("data-dimension-name");
			var dimensionMap = $('input[name="' + dimension + '"]:checked').data('dimension-map');
			if (dimensionMap != null && dimensionMap != 'undefined') {
				selectedDimensionMap += (selectedDimensionMap.length > 0 ? '-' : '') + dimensionMap;
			}
		});

		if ($(this).siblings('label').hasClass('available')) {
			$('#multi-variations span').each(function(i) {
				var dataValue = $(this).attr("data-combination-map");
				// If combination found, redirect it to the product page
				if (dataValue === selectedDimensionMap) {
					var url = ACC.config.encodedContextPath + productCatUrl + '/p/' + $(this).attr("id");
					window.location.href = url;
				}
			});
		}
		else if ($(this).siblings('label').hasClass('inactive')) {
			var dimensionArray = selectedDimensionMap.split('-');
			var index = dimensionArray.indexOf(selectedDimension);
			var newDimensionMap = (index === 0 ? selectedDimension + "-" : (index === dimensionArray.length - 1 ? "-" + selectedDimension : "-" + selectedDimension + "-"));

			var newList = [];
            $('#multi-variations span').each(function (i) {
                var dataValue = $(this).attr("data-combination-map");
                if (dataValue.includes(newDimensionMap)) {
                    let dataValueArray = dataValue.split('-');
                    dataValueArray.map((data) => {
                        if (+selectedDimension === +data) {
                            newList.push($(this));
                        }
                    })
                }
            });

			// Iterate through newList
			newList.forEach(function(item, index) {
				var currentDataValue = item.attr("data-combination-map").split('-');
				var tempCounter = 0;

				currentDataValue.forEach(function(element, i) {
					if (element[i] === dimensionArray[i]) {
						tempCounter++;
					}
				});
				if (index === 0 || (tempCounter > 1 && tempCounter > counter)) {
					productId = item.attr("id");
					counter = tempCounter;
				}
			});
			window.location.href = ACC.config.encodedContextPath + productCatUrl + '/p/' + productId;
		}
	});

	//About This Item collapse JS
	$(".AboutThisItemContainer a").on("click", function() {
		$("#specCollapse1").collapse("hide");
	});
	$(".SpecContainer a").on("click", function() {
		$("#specCollapse").collapse("hide");
	});

	//Js for star ratings:
	$('.stars-container').each(function() {
		let rate = $(this).data('rate');
		let starsfill = $(this).find('.starfill');

		for (let i = 0; i < 5; i++) {
			let star = starsfill.eq(i);

			if (rate > i) {
				if (rate < i + 1) {
					star.css('width', `${(rate - i) * 100}%`);
				} else {
					star.css('width', '100%');
				}
			} else {
				star.css('width', '0%');
			}
		}
	});

	initCarousel();

});

// carousel on pdp
function initCarousel() {
	if ($(window).width() <= 640) {
		$(".product-variant").each(function() {
			$(this).owlCarousel({
				loop: false,
				nav: false,
				dots: false,
				touchDrag: true,
				mouseDrag: true,
				autoWidth: true,
			});
		});
	} else {
		$(".product-variant").trigger('destroy.owl.carousel');
	}
}
$(window).resize(initCarousel);

$(window).on('load', function () {
    const isAshleyProduct = $('#isAshleyProduct').attr('data-value');
	if(isTrue(isAshleyProduct)) {
		var modelUrl;
		var mxtUrl = $('#product360CdnUrl').attr('data-value');
		var modelViewerUrl = $('#product360ModalViewerUrl').attr('data-value');
		$.getScript(mxtUrl, function() {
			async function addSrcToModelViewer() {
				const sku = $('#productModelNumber').val();
				const myApiKey = $('#product360SpinApiKey').attr('data-value');
				const myClientId = $('#clientID').attr('data-value');
				const pregenerated = new MxtWebAR.MxtWebArPregenerated({apiKey: myApiKey , clientId: myClientId });
				const lod = 1024;
				try {
					modelUrl = await pregenerated.getGlb(sku, lod);
					if (modelUrl) {
						if($('#pdpImgThumbnail .owl-stage-outer').length > 0) {
							$('#pdpImgThumbnail .owl-stage-outer').append($('.open-product-360-modal'));
							$('#pdpImgThumbnail .open-product-360-modal').fadeIn(300).css("display","inline-block");
						} else {
							$('#pdpImgThumbnail').append($('.open-product-360-modal'));
							$('#pdpImgThumbnail .open-product-360-modal').fadeIn(300).css("display","inline-block");
						}
					}
				} catch(e) {
					console.error('Failed to get sku web ar asset', e);
				}
			}
			addSrcToModelViewer();
		});
		$(document).on('click', '.open-product-360-modal', function () {
			var modelScript = document.createElement("script");
			modelScript.type = "module"
			modelScript.src = modelViewerUrl;
			$('body').append(modelScript);
			$('body').addClass('modal-open');
			$('.product-360-spin-view-wrapper').fadeIn(300);
			$('#product360SpinModel').attr('src', modelUrl);
		})
		$(document).on('click', '.close-360-icon', function() {
			$('body').removeClass('modal-open');
			$('.product-360-spin-view-wrapper').fadeOut(300);
		});
	}
});